export class CreateProjectRequest {

    constructor(
        organizationDetails,
        projectProperties,
        userProperties,
        entities,
        relations,
        portals,
        configurations,
        roles,
        portalSettings
    ) {
        this.organizationDetails = organizationDetails;
        this.projectProperties = projectProperties;
        this.userProperties = userProperties;
        this.entities = entities;
        this.relations = relations;
        this.portals = portals || [];
        this.configurations = configurations || [];
        this.roles = roles || [];
        this.portalSettings = portalSettings || {};
    }
}